import { helpbuttonStyle } from '@bingads-webui-campaign-react/common-styles';

export const getChooseObjectiveStyles = (_, { palette = {} }) => ({
  '@global': helpbuttonStyle({ palette }),
  chooseObjective: {
    // Used by StyledCampaignChooseObjective, can be removed if removed there.
  },
  pageContent: {
    marginTop: 35,
    marginLeft: 18,
    minHeight: 450,
  },
  description: {
    marginTop: 24,
    fontSize: 14,
    lineHeight: '24px',
    color: palette.neutralPrimary,
  },
});
